export default __webpack_public_path__ + "static/media/smartphone.f4b07824.svg";